import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

// Amplify/Cognito bootstrap. Named configureAppSync for historical reasons —
// AppSync has been retired (D-2: user/social CRUD is REST). This now configures
// ONLY Cognito auth; there is no GraphQL/AppSync endpoint dependency, so the app
// works without AppSync.

// Track if Amplify has been configured
let isAmplifyConfigured = false;

// Configure Amplify (Cognito auth only).
export const configureAppSync = () => {
  console.log('Configuring Amplify (Cognito)');
  try {
    // Validate required environment variables
    if (!process.env.REACT_APP_COGNITO_USER_POOL_ID) {
      return false;
    }

    if (!process.env.REACT_APP_COGNITO_CLIENT_ID) {
      return false;
    }

    const amplifyConfig = {
      Auth: {
        Cognito: {
          userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
          userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        }
      }
    };

    Amplify.configure(amplifyConfig);
    
    // Configure Cognito to use localStorage for token persistence
    // Create a custom storage that uses localStorage
    const customStorage = {
      setItem: (key: string, value: string) => {
        localStorage.setItem(key, value);
        return Promise.resolve();
      },
      getItem: (key: string) => {
        const value = localStorage.getItem(key);
        return Promise.resolve(value);
      },
      removeItem: (key: string) => {
        localStorage.removeItem(key);
        return Promise.resolve();
      },
      clear: () => {
        localStorage.clear();
        return Promise.resolve();
      }
    };
    
    cognitoUserPoolsTokenProvider.setKeyValueStorage(customStorage);
    
    console.log('✅ Amplify configured with localStorage for token persistence');
    isAmplifyConfigured = true;
    return true;
  } catch (error) {
    console.error('❌ Failed to configure AppSync:', error);
    return false;
  }
};

// Check if Amplify is configured
export const isConfigured = () => isAmplifyConfigured;
